import produce from 'immer';
export function updateUserInMetaConversation(metaConversation, user) {
    return produce(metaConversation, (draftMetaConversation) => {
        var _a, _b, _c;
        const authors = draftMetaConversation.conversation.authors;
        for (const authorId in authors) {
            if (user.id === authorId) {
                authors[authorId] = user;
            }
        }
        if (((_a = draftMetaConversation.requester) === null || _a === void 0 ? void 0 : _a.id) === user.id) {
            draftMetaConversation.requester = user;
        }
        (_b = draftMetaConversation.messages) === null || _b === void 0 ? void 0 : _b.forEach((message) => {
            if (message.author.id === user.id) {
                message.author = user;
            }
        });
        (_c = draftMetaConversation.linkedConversations) === null || _c === void 0 ? void 0 : _c.forEach((linkedConversation) => {
            if (linkedConversation.requester.id === user.id) {
                linkedConversation.requester = user;
            }
        });
    });
}
